/**
 * To kick things off, we will first load any dependencies for the project
 * including our bootstrap, lazysizes for lazy loading both images and
 * background images as well as Vue to create a robust foundation.
 */

require('./bootstrap');

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'spotlight.js/dist/spotlight.bundle.js';

window.Vue = require('vue');

// Form Validation
Vue.use(require('vee-validate'));

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components', true, /\.vue$/i);

files.keys().map(key => {
    return Vue.component(key.split('/').pop().split('.')[0], files(key).default);
});

/**
 * Next, we will create a fresh Vue application instance and attach it to the page. We also
 * create another global Vue instance for handling events, this allows us to share both
 * data and state between each individual Vue component within our application scope.
 */

import MarqueeText from 'vue-marquee-text-component';

Vue.component('marquee-text', MarqueeText);

import Flickity from 'vue-flickity';

Vue.component('flickity', Flickity);

import VScrollLock from 'v-scroll-lock';

Vue.use(VScrollLock);

window.Events = new Vue();

const app = new Vue({
    el: '#app',

    data() {
        return {
            navActive: false,
            showHeader: true,
            scrollPosition: 0,
        }
    },

    mounted() {
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        const toggleHeader = () => {
            this.toggleHeader();

            window.requestAnimationFrame(toggleHeader);
        };

        window.requestAnimationFrame(toggleHeader);
    },

    methods: {
        toggleNav() {
            this.navActive = !this.navActive;
        },

        toggleDescription() {
            this.descriptionActive = !this.descriptionActive;
        },

        toggleHeader() {
            const threshold = 20;
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosition === this.scrollPosition) {
                return;
            }

            if (scrollPosition > 0 && scrollPosition > this.scrollPosition + threshold) {
                this.showHeader = false;

                this.scrollPosition = scrollPosition;
            }

            if (scrollPosition < this.scrollPosition - threshold) {
                this.showHeader = true;

                this.scrollPosition = scrollPosition;
            }
        },
    },
});

document.body.classList.remove('preload');
